import React from 'react'
import { useSelector } from 'react-redux'
import { Routes, Route, Navigate } from 'react-router-dom'

import { CompanyProfileComponent } from '../../company-profile'
import { UserProfileComponent } from '../../user-profile'
import { PasswordProfile } from '../../password-profile'
import { MailingConfigComponent } from '../../mailing-config/components'
import { AdhesionOpComponent } from '../../adhesion-op'
import { canAccessMailingConfig } from '../components/profile-tabs/profile-tabs.constants'

export const ProfileRouter = () => {
  const role = useSelector((state) => state.global.role)
  const isPrescriptor = role === 'administrador_prescriptor'

  return (
    <Routes>
      <Route index element={<Navigate to="user" replace />} />
      <Route path="user" element={<UserProfileComponent />} />
      <Route path="change-password" element={<PasswordProfile />} />
      <Route path="company" element={<CompanyProfileComponent />} />
      <Route
        path="adhesion-op"
        element={isPrescriptor ? <AdhesionOpComponent /> : <Navigate to="user" replace />}
      />
      <Route
        path="mailing"
        element={
          canAccessMailingConfig(role) ? <MailingConfigComponent /> : <Navigate to="user" replace />
        }
      />
      <Route path="*" element={<Navigate to="user" replace />} />
    </Routes>
  )
}
